import { combineReducers } from 'redux'
import { configureStore } from '../../core'
import { stores } from './features'
import { normalizeContent } from '../../core/normalize'

export default content => {
  return configureStore(
    combineReducers(stores),
    normalizeContent(content),
  )
}
